var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23828 5.14453C8.23828 7.83984 6.75 9.52734 4.38281 9.52734C2.02734 9.52734 0.527344 7.83984 0.527344 5.14453C0.527344 2.46094 2.02734 0.761719 4.38281 0.761719C6.75 0.761719 8.23828 2.46094 8.23828 5.14453ZM4.38281 7.45312C5.14453 7.45312 5.61328 6.58594 5.61328 5.13281C5.61328 3.67969 5.14453 2.80078 4.38281 2.80078C3.62109 2.80078 3.15234 3.67969 3.15234 5.13281C3.15234 6.58594 3.62109 7.45312 4.38281 7.45312ZM5.03906 18H2.20312L8.76562 9.01172L14.543 1.08984H17.3672L10.9922 9.83203L5.03906 18ZM19.043 13.8516C19.043 16.5469 17.5547 18.2461 15.1875 18.2461C12.832 18.2461 11.332 16.5469 11.332 13.8516C11.332 11.168 12.832 9.46875 15.1875 9.46875C17.5547 9.46875 19.043 11.168 19.043 13.8516ZM15.1875 16.1602C15.9492 16.1602 16.418 15.293 16.418 13.8398C16.418 12.3867 15.9492 11.5078 15.1875 11.5078C14.4258 11.5078 13.957 12.3867 13.957 13.8398C13.957 15.293 14.4258 16.1602 15.1875 16.1602Z",
    fill: "#D65AEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountLogo);
export default __webpack_public_path__ + "static/media/discount_logo.7bb7a1a2feb51763591a0a8b044ad44d.svg";
export { ForwardRef as ReactComponent };